export default {
  id: 1525,
  name: 'Greek Chicken',
  short_description: 'Cauliflower tabbouleh with cucumber, tahini sauce',
  calories: 533,
  image: '/g/r/greek-chicken.jpeg',
  image_path: '/media/catalog/product/cache/x600/',
  price: 13.49,
  sku: 'KETO-GREEK-CHICKEN',
  category_id: 3,
  chef_id: 6982,
  chef_firstname: 'Ruben',
  chef_lastname: 'Garcia',
  new_meal: false,
  new_chef: false,
  logopic: '/media/avatar/garcia-th95905.jpg',
  stock: 10,
  inStock: true,
  meat_type: 'Chicken',
  stars: 4.256,
  reviews: 125,
  sidedish: null,
  specifications_detail: [
    { label: 'Paleo', __typename: 'specificationsDetailType' },
    { label: 'Keto Diet', __typename: 'specificationsDetailType' },
    { label: 'Dairy Free', __typename: 'specificationsDetailType' },
    { label: 'Gluten Free', __typename: 'specificationsDetailType' },
    { label: 'High Fat', __typename: 'specificationsDetailType' },
    { label: 'High Protein', __typename: 'specificationsDetailType' },
    { label: 'Hormone Free', __typename: 'specificationsDetailType' },
    {
      label: 'Less Than 600 calories',
      __typename: 'specificationsDetailType'
    },
    { label: 'Low Carbs', __typename: 'specificationsDetailType' },
    { label: 'Low Sodium', __typename: 'specificationsDetailType' },
    { label: 'Nuts Free', __typename: 'specificationsDetailType' },
    { label: 'Paleo', __typename: 'specificationsDetailType' },
    { label: 'Whole 30', __typename: 'specificationsDetailType' }
  ],
  __typename: 'menuMealType'
}



// WEBPACK FOOTER //
// ./src/modules/Menu/Meals/skeletonData.js